import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from "./store/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;
    if (to.hash) scrollTo = to.hash;
    else if (savedPosition) scrollTo = savedPosition.y;
    return goTo(scrollTo);
  },
  routes: [
    {
      path: "/",
      redirect: () => {
        const ok = store && store.getters && store.getters.getLoginStatus;
        return ok ? "/director-comercial" : "/login";
      },
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        { name: "DcDashboard", path: "director-comercial",
          component: () => import("@/components/DirectorComercial/DashboardDC") },
        { name: "DcProspectosListado", path: "director-comercial/prospectos",
          component: () => import("@/components/DirectorComercial/ProspectosListado") },
        { name: "DcProspectoDetalle", path: "director-comercial/prospectos/:id",
          component: () => import("@/components/DirectorComercial/ProspectoDetalle") },
        { name: "DcProspectosKanban", path: "director-comercial/kanban",
          component: () => import("@/components/DirectorComercial/ProspectosKanban") },
        { name: "DcPropuestasListado", path: "director-comercial/propuestas",
          component: () => import("@/components/DirectorComercial/PropuestasListado") },
        { name: "DcPropuestaWizard", path: "director-comercial/propuestas/nueva",
          component: () => import("@/components/DirectorComercial/PropuestaWizard") },
        { name: "DcEstrategias", path: "director-comercial/estrategias",
          component: () => import("@/components/DirectorComercial/EstrategiasListado") },
        { name: "DcPoliticas", path: "director-comercial/politicas",
          component: () => import("@/components/DirectorComercial/PoliticasListado") },
        { name: "DcBrochure", path: "director-comercial/brochure",
          component: () => import("@/components/DirectorComercial/BrochureEditor") },
        { name: "DcCampanas", path: "director-comercial/campanas",
          component: () => import("@/components/DirectorComercial/CampanasListado") },
        { name: "DcAlianzas", path: "director-comercial/alianzas",
          component: () => import("@/components/DirectorComercial/AlianzasKanban") },
        { name: "DcDocumentosHistorial", path: "director-comercial/documentos",
          component: () => import("@/components/DirectorComercial/DocumentosHistorial") },
        { name: "DcHerramientasVentas", path: "director-comercial/herramientas",
          component: () => import("@/components/DirectorComercial/HerramientasVentas") },
        { name: "DcPresentacionComercial", path: "director-comercial/presentacion-comercial",
          component: () => import("@/components/DirectorComercial/PresentacionComercial") },
        { name: "DcVideos", path: "director-comercial/videos",
          component: () => import("@/components/DirectorComercial/VideosListado") },
        { name: "DcImagenes", path: "director-comercial/imagenes",
          component: () => import("@/components/DirectorComercial/ImagenesGaleria") },
        { name: "DcPresentaciones", path: "director-comercial/presentaciones",
          component: () => import("@/components/DirectorComercial/PresentacionesListado") },
        { name: "DcUsuariosAdmin", path: "director-comercial/usuarios",
          component: () => import("@/components/DirectorComercial/UsuariosAdmin") },
        { name: "DcMasOpciones", path: "director-comercial/mas",
          component: () => import("@/components/DirectorComercial/MasOpciones") },
        { name: "DcClientesListado", path: "director-comercial/clientes",
          component: () => import("@/components/DirectorComercial/ClientesListado") },
        { name: "DcClienteDetalle", path: "director-comercial/clientes/:id",
          component: () => import("@/components/DirectorComercial/ClienteDetalle") },
      ],
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/layouts/full-layout/Login"),
    },
    {
      path: "*",
      component: () => import("@/layouts/full-layout/NotFound"),
      meta: { requiresAuth: false },
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  NProgress.start(800);
  store.commit("setRouterHistory", from);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    store.commit("setRouteData", { requireAuth: true });
    if (store.getters.getLoginStatus) {
      next();
      return;
    }
    next("/login");
  } else {
    store.commit("setRouteData", { requireAuth: false });
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
